/* Shared CSV output rules for catalog exports, order reports and the sample. */
((root) => {
  'use strict';

  function quote(value) {
    let text = String(value ?? '').replace(/[\u0000-\u001f\u007f-\u009f]/g, ' ');
    // CSV quotes escape delimiters, but do not stop spreadsheet formulas.
    if (/^\s*[=+\-@＝＋－＠]/u.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  }

  function encode(rows) {
    return '\uFEFF' + rows.map((row) => row.map(quote).join(',')).join('\r\n') + '\r\n';
  }

  function download(contents, filename) {
    const url = URL.createObjectURL(new Blob([contents], { type: 'text/csv;charset=utf-8;' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.append(link);
    link.click();
    link.remove();
    // Keep the URL alive long enough for browsers to start reading the download.
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }

  const api = { encode, download };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else if (!root.RetailerCSV) root.RetailerCSV = api;
})(typeof window === 'undefined' ? globalThis : window);
